class MFRNokaProductSubscriptionSection {
  constructor(i, e) {
    this.$index = i
    this.$element = $(e)

    this.selectors = {
      variantSelector: ".variant-selector",
      variantSelectorOptions: ".variant-selector__options",
      variantInputSelectors: ".variant-selector input[type='radio']",
      subscriptionSelector: ".subscription-selector",
      subscriptionSelectorOptions: ".subscription-selector__options",
      variantPriceOriginal: ".product-previous-price",
      variantPriceDiscounted: ".product-current-price",
      variantPricePerPiece: ".per-piece-price",
      variantPricePerPieceContainer: ".product-price-per-piece",
      container: ".main-container",
      products: ".product-list-item",
      title: ".product-title",
      image: ".product-featured-image",
      features: ".product-top__product-features",
      modal: ".mfr-product__nfp",
      addToCart: ".add-to-cart"
    }

    this.forms = {
      form: ".product-top__form",
      masterInput: "input[name='id']",
      hiddenInputId: "input[name='product-id']",
      hiddenInputPrice: "input[name='properties[_current_price]']",
      hiddenInputThemeColor: "input[name='properties[_bg_color]']",
      hiddenInputTitle: "input[name='properties[_nice_title]']",
      hiddenInputsubscriptionPlanId: "input[name='properties[_subscription_id]']"
    }

    this.jsons = {
      productJSONScript: ".product-list__json[type='application/json']"
    }

    this.states = {
      price: 0,
      discount: 0,
      discounted_price: 0,
      pack_count: 0,
      price_per_piece: 0,
    }

    this.init()
  }

  init() {
    this.$form = this.$element.find(this.forms.form)
    this.$masterInput = this.$element.find(this.forms.masterInput)
    this.$hiddenInputId = this.$element.find(this.forms.hiddenInputId)
    this.$hiddenInputPrice = this.$element.find(this.forms.hiddenInputPrice)
    this.$hiddenInputThemeColor = this.$element.find(this.forms.hiddenInputThemeColor)
    this.$hiddenInputTitle = this.$element.find(this.forms.hiddenInputTitle)
    this.$hiddenInputsubscriptionPlanId = this.$element.find(this.forms.hiddenInputsubscriptionPlanId)
    
    this.$variantSelector = this.$element.find(this.selectors.variantSelector)
    this.$variantSelectorOptions = this.$element.find(this.selectors.variantSelectorOptions)
    this.$variantInputSelectors = this.$element.find(this.selectors.variantInputSelectors)
    this.$subscriptionSelector = this.$element.find(this.selectors.subscriptionSelector)
    this.$subscriptionSelectorOptions = this.$element.find(this.selectors.subscriptionSelectorOptions)

    this.$variantPriceOriginal = this.$element.find(this.selectors.variantPriceOriginal)
    this.$variantPriceDiscounted = this.$element.find(this.selectors.variantPriceDiscounted)
    this.$variantPricePerPiece = this.$element.find(this.selectors.variantPricePerPiece)
    this.$variantPricePerPieceContainer = this.$element.find(this.selectors.variantPricePerPieceContainer)

    this.$title = this.$element.find(this.selectors.title)
    this.$image = this.$element.find(this.selectors.image)
    this.$container = this.$element.find(this.selectors.container)
    this.$modal = this.$element.find(this.selectors.modal)
    this.$features = this.$element.find(this.selectors.features)
    this.$addToCart = this.$element.find(this.selectors.addToCart)
    this.$productItems = this.$element.find(this.selectors.products)

    this.$currency = this.$form.data("currency")
    this.$productJSONScript = this.$element.find(this.jsons.productJSONScript)
   
    this.$productItems.on("click", this.__handleProductChange.bind(this))
    this.$variantInputSelectors.on("change", this.__handleVariantChange.bind(this))
  }

  __handleVariantChange(e) {
    this.__handleUpdateSubscriptionSelectorPrices(e)
  }

  __handlePricesChange() {
    this.$variantPriceOriginal.text(`${this.$currency}${this.toFixed(this.states.price, 2)}`)
    this.$variantPriceDiscounted.text(`${this.$currency}${this.toFixed(this.states.discounted_price, 2)}`)
    this.$variantPricePerPiece.text(`${this.$currency}${this.toFixed(this.states.price_per_piece, 2)}`)
    this.$addToCart.find(".price").text(`${this.$currency}${this.toFixed(this.states.discounted_price, 2)}`)
  }

  __handleUpdateSubscriptionSelectorPrices(e) {
    if (!this.$subscriptionSelector.length) return

    let basePrice = parseFloat(this.$form.data("base-price")),
        discount = this.$subscriptionSelector.mfrSubscriptionSelector("get-discount"),
        packCount = Number($(e.currentTarget).data("packcount")),
        discountedPrice = basePrice - (basePrice * discount)

    this.states = {
      price: basePrice,
      discount: discount,
      discounted_price: discountedPrice,
      pack_count: packCount,
      price_per_piece: discountedPrice / packCount,
    }

    this.__handlePricesChange()
  }

  __handleProductChange(e) {
    e.preventDefault()

    const $selectedProduct = $(e.currentTarget)
    const id = Number($selectedProduct.data('id'))

    this.$productItems.removeClass('is-active')
    $selectedProduct.addClass('is-active')

    this.__handleContentUpdates(id)
  }

  __handleVariantChangeAfterProductSwitch(variants, discount) {
    $(document).on("click", this.selectors.variantInputSelectors, (e) => {
      const id = Number($(e.currentTarget).data('variant'))

      this.__handleUpdateMasterInput(id)
      
      let selectedVariant = variants.filter(variant => variant.id === id)

      if (!selectedVariant.length) return

      const { price, pack_count } = selectedVariant[0]

      this.states = {
        price: price,
        discount: discount,
        discounted_price: price - (price * discount),
        pack_count: pack_count,
        price_per_piece: (price - (price * discount)) / pack_count,
      }

      this.__handlePricesChange()
    })
  }

  __handleContentUpdates(selectedId) {
    const selectedProductFromList = this.getProductListData().filter(product => product.id === selectedId)

    if (!selectedProductFromList) return

    const {id, handle, nice_title, image, original_price, discount_value, subscription_id, variants, selling_plan_groups, options_with_values, out_of_stocks, nutritional_facts, key_benefits, theme_color} = selectedProductFromList[0]

    this.states = {
      price: original_price,
      discount: discount_value,
      discounted_price: original_price - (original_price * discount_value),
      pack_count: variants[0].pack_count,
      price_per_piece: (original_price - (original_price * discount_value)) / variants[0].pack_count,
    }

    this.__handleUpdateMasterInput(variants[0].id)
    this.__handlePerPieceContainerVisibility(variants[0].pack_count)
    this.__handleProductOutOfStocksState(out_of_stocks)
    this.__handleProductFormAttributesChange(id, handle, original_price)
    this.__handleProductFormHiddenInputsChange(id, original_price, subscription_id, nice_title, theme_color)
    this.__handleProductSubscriptionOptionsChange(selling_plan_groups)
    this.__handleProductVariantOptionsChange(variants, options_with_values)
    this.__handleVariantChangeAfterProductSwitch(variants, discount_value)
    this.__handleProductBenefitsContentChange(key_benefits)
    this.__handleProductModalContentChange(nutritional_facts)
    this.__handleProductMainContentChange(nice_title, image, theme_color)
  }

  __handleUpdateMasterInput(id, productId) {
    this.$masterInput.val(id)

    if (productId) {
      this.$masterInput.attr("data-productid", id)
    }
  }

  __handlePerPieceContainerVisibility(count) {
    (count <= 1) ? this.$variantPricePerPieceContainer.hide() : this.$variantPricePerPieceContainer.show()
  }

  __handleProductOutOfStocksState(oos) {
    if (oos) {
      this.$form.addClass('sold-out')
      this.$addToCart.attr('disabled', true)
    } else {
      this.$form.removeClass('sold-out')
      this.$addToCart.attr('disabled', false)
    }
  }

  __handleProductFormAttributesChange(id, handle, price) {
    this.$form.attr({
      "id": `product_form_${id}`,
      "data-product-id": id,
      "data-productid": id,
      "data-product-handle": handle,
      "data-base-price": price
    })
  }

  __handleProductFormHiddenInputsChange(id, price, subscriptionId, title, color) {
    this.$hiddenInputId.val(id)
    this.$hiddenInputTitle.val(title)
    this.$hiddenInputPrice.val(price)
    this.$hiddenInputThemeColor.val(color)
    this.$hiddenInputsubscriptionPlanId.val(subscriptionId)
  }

  __handleProductSubscriptionOptionsChange(subsriptionArray) {
    let subscriptionHTML = ""

    subsriptionArray.forEach((plan, index) => {
      subscriptionHTML += `
        <label for="subscription-${plan.id}">
          <input id="subscription-${plan.id}" type="radio" name="selling_plan" value="${plan.id}" ${index == 0 ? "checked" : ""}>
          <div class="subscription-selector__option">
            <span data-subscription-selector-option="${plan.name}">${plan.name}</span>
          </div>
        </label> 
      `
    })

    this.$subscriptionSelectorOptions.html(subscriptionHTML) 
  }

  __handleProductVariantOptionsChange(variantsArray, optionsValues) {
    let variantsHTML = ""

    variantsArray.forEach((variant, index) => {
      variantsHTML += `
        <label for="radio-${this.toHandleize(optionsValues.name)}-${index}" class="is-inview ${variant.total_inventory > 0 ? "" : "out-of-stock"}">
          <input type="radio" 
            name="${optionsValues.name}" 
            value="${variant.name}" 
            id="radio-${this.toHandleize(optionsValues.name)}-${index}" 
            data-variant="${variant.id}" 
            data-packcount="${variant.pack_count}"
            ${index === 0 && variant.total_inventory > 0 ? "checked" : ""}>

          <div class="variant-selector__option">
            <div class="text">
              <span class="small">${variant.nice_title ? variant.nice_title : variant.name}</span>
              <span class="xsmall">${variant.sub_title}</span>
            </div>
          </div>
      </label>
      `
    })

    this.$variantSelectorOptions.html(variantsHTML)
  }

  __handleProductBenefitsContentChange(benefitsArray) {
    let keyBenefitsHTML = ""

    benefitsArray.forEach((benefit, index) => {
      keyBenefitsHTML += `
        <li class="is-inview">
          <span>
            <img src="${benefit.icon}" alt="${benefit.title}">
          </span>
          <p>${benefit.title}</p>
        </li>
      `
    })

    this.$features.html(keyBenefitsHTML) 
  }

  __handleProductModalContentChange(modalContent) {
    this.$modal.find('.title').text(`${modalContent.title}`)
    this.$modal.find('.description').html(`<p>${modalContent.description}</p>`)
    this.$modal.find('.image').html(`<img src='${modalContent.image}' alt="${modalContent.title}">`)
  }

  __handleProductMainContentChange(title, image, color) {
    this.$title.text(title)
    this.$container.css("--product-theme-color", color)
    this.$image.html(`<img src='${image}' alt="${title}" class="product-featured-image">`)
    
    this.__handlePricesChange()
  }

  getProductListData() {
    this.productListData = this.productListData || JSON.parse(this.$productJSONScript.text())
    return this.productListData
  }

  toHandleize(value) {
    return value.replace(/ /g, '-').toLowerCase()
  }

  toFixed(value, dp) {
    return +parseFloat(value).toFixed(dp)
  }
}